import React from "react";
import {Col, Label, Row} from "reactstrap";
import SelectDate from "./SelectDate.mjs";
import SelectTime from "./SelectTime.mjs";
import IndefiniteProgressbar from "../IndefiniteProgressbar.mjs";
import {email2link, mins2hm, ts2dmmm, ts2hhmm, ts2hmm, hm2mins, ts2ymd} from "../../Services/Conversions.mjs";
import {globalMaxTime, globalMinTime, WeekdaysName} from "../../Services/Constants.mjs";
import "../../media/css/TsInterval.css";

const TsInterval = class extends React.Component {
	constructor(props={}) {
		super(props);
		this.state = {
			visible: typeof props.visible === 'boolean' ? props.visible : ! (props.deps && props.deps.field),
			formData: {},
			myPrefix: props.globPrefix ? props.globPrefix +'tsinterval' : undefined,
			labelWidth: props.labelWidth ?? 3,
			label: props.label ?? "Scegliere data e ora",
			minDate: 1,
			maxDate: 30,
			minTime: props.minTime ?? globalMinTime,
			maxTime: props.maxTime ?? globalMaxTime
		};
		if ( props.parent ) {
			if ( props.parent.tinizio ) {
				this.state.formData.date = ts2ymd(props.parent.tinizio);
				this.state.formData.timeStart = ts2hhmm(props.parent.tinizio);
			}
			if ( props.parent.tfine ) {
				this.state.formData.timeEnd = ts2hhmm(props.parent.tfine);
			}
		}
		this.state.fieldWidth = props.fieldWidth ?? ( 12 - this.state.labelWidth);
		this.uid = "TsInterval-"+window.glob.generateUid();
		this.updatecomments = this.updatecomments.bind(this);
		this.save = this.save.bind(this);
		this.fetchSlot = this.fetchSlot.bind(this);
		this.fetchSlotData = this.fetchSlotData.bind(this);
	}
	componentDidMount() {
		if ( this.props.globPrefix && this.props.deps ) {
			const p = this.props.globPrefix;
			window.glob.register(`${p}changed.${this.props.deps.field}`,(v)=> {
				const s = { visible: !! v };
				if ( s.visible ) {
					const p = window.glob.getStatus('prenotazione.values');
					if ( p && p.slot ) {
						s.minDate = p.slot.dtstart;
						s.maxDate = p.slot.dtend;
					}
				}
				this.setState(s);
			}, this.uid );
			window.glob.register([`${p}changed.ente`,`${p}changed.of`,`${p}changed.slot`],()=>{
				this.setState({ slotData: false });
			},`${this.uid}-slotData`);
		}
		if ( this.state.myPrefix ) {
			const p = this.state.myPrefix;
			window.glob.register(`${p}changed`, (w) => {
				if (typeof w !== 'object') return;
				if (typeof w.name !== 'string') return;
				const formData = this.state.formData;
				formData[ w.name] = w.value;
				this.setState({ formData: formData });
				this.updatecomments();
				window.glob.trigger(`${p}changed.${w.name}`, w.value).then(() => {
					this.save();
				});
			}, this.uid);
		}
	}
	componentWillUnmount() {
		if ( this.props.globPrefix && this.props.deps ) {
			const p = this.props.globPrefix;
			window.glob.unregister(`${p}changed.${this.props.deps.field}`, this.uid );
			window.glob.unregister([`${p}changed.ente`,`${p}changed.of`,`${p}changed.slot`],`${this.uid}-slotData`);
		}
		if ( this.state.myPrefix ) {
			const p = this.state.myPrefix;
			window.glob.unregister([`${p}changed`],  this.uid);
		}
	}
	updatecomments(){
		this.conflictDetected = false;
		if ( ! Array.isArray(this.state.slotData) ) {
			if (! this.fetchingSlotData) setTimeout(() => { this.fetchSlotData() }, 100);
			if ( ! this.refreshingComments ) this.refreshingComments = setTimeout(() => { this.updatecomments() }, 200);
			return "";
		}
		if ( this.refreshingComments ) delete this.refreshingComments;
		const comment = (f,l) => {
			const t = document.getElementById(this.uid+f+'-comment');
			if ( t ) t.innerHTML = ( typeof l === "string" && l.length ) ? l : "";
		}
		comment("date","");
		comment("timeStart","");
		comment("timeEnd","");
		const parent = this.props?.parent?.parent?.of ?? this.props?.parent?.of ?? this.props?.parent;
		if ( this.state.formData.date && this.state.formData.date.length ) {
			const currentEmail = window.glob.getStatus('login')?.mail;
			let sd = (this.state.slotData || []).filter( s => (
				s.tinizio.startsWith(this.state.formData.date) &&
				s?.lofanno === parent?.lannocorso
			));
			if ( parent?.kprenotazione ) sd = sd.filter( s => (s.kprenotazione !== parent.kprenotazione) );
			const mailLink = s => email2link(
				s.email,
				{
					string: true,
					text: s.lofnome,
					title: `Invia una mail a ${s.email}`,
					subject: `A proposito della prenotazione per il ${ts2dmmm(s.tinizio)} - ${ s.lofnome }`
				}
			);
			const slotLocked = '<span class="prenotazioneLocked" title="Questa prenotazione è bloccata: è stata approvata ed è già parte degli orari ufficiali."></span>';
			const slotComment = (dt) =>{
				if ( dt === "" ) return "";
				if ( sd.length === 0 ) return ", nessuna prenotazione in possibile conflitto.";
				let h = `, possibili conflitti: ${sd.length}`;
				//console.log(sd);
				sd
					.sort( (a,b) => ( a.tinizio > b.tinizio ? 1 : -1 ))
					.forEach( s => {
						h += `<br />· Dalle ${ts2hmm(s.tinizio)} alle ${ts2hmm(s.tfine)}, ${ s.email === currentEmail ? '['+s.lofnome+']' : mailLink(s) }`;
						if ( parseInt(s.kfrozen) > 0 ) h += slotLocked;
					}
				);
				return h;
			};
			const c = WeekdaysName[new Date(this.state.formData.date).getDay()];
			comment("date", c + slotComment(this.state.formData.date) );
			if ( this.state.formData.timeStart && this.state.formData.timeEnd ) {
				comment("timeEnd", "Durata: "+mins2hm( hm2mins(this.state.formData.timeEnd) - hm2mins(this.state.formData.timeStart)));
				const slotData = parent?.kslotprenotazione ? parent : window.glob.getStatus('prenotazione.values').slot;
				const oldPrenoData = JSON.parse(JSON.stringify(parent));
				const globData = window.glob.getStatus(this.props.globPrefix+'values');
				if ( ! oldPrenoData.of ) oldPrenoData.of = globData?.of;
				if ( ! oldPrenoData.ente ) oldPrenoData.ente = globData?.ente;
				const newPrenoData = this.state.formData;
				window.glob.slot.conflitti(slotData,oldPrenoData,newPrenoData).then( conflitti => {
					if ( conflitti && conflitti.length ) {
						this.conflictDetected = true;
						comment("timeStart",'<b class="error">ATTENZIONE: ORARIO IN CONFLITTO.</b>')
					} else {
						comment("timeStart","Orario disponibile.")
					}
					window.glob.trigger(this.props.globPrefix+'conflitto', this.conflictDetected);
				});
				// const ts = this.state.formData.date + ' ' + this.state.formData.timeStart + ':00';
				// const te = this.state.formData.date + ' ' + this.state.formData.timeEnd + ':00';
				// if ( sd.find( s => ( s.tinizio < te && s.tfine > ts ))) {
				// 	this.conflictDetected = true;
				// 	comment("timeStart",'<b class="error">ATTENZIONE: ORARIO IN CONFLITTO.</b>')
				// } else {
				// 	this.conflictDetected = false;
				// 	comment("timeStart","Orario disponibile.")
				// }
				// comment("timeEnd", "Durata: "+mins2hm( hm2mins(this.state.formData.timeEnd) - hm2mins(this.state.formData.timeStart)));
			}
		} else {
			window.glob.trigger(this.props.globPrefix+'conflitto', false);
		}
	}
	save(){
		if ( this.props.globPrefix && this.props.name ) {
			window.glob.trigger(this.props.globPrefix+'conflitto', this.conflictDetected);
			if ( this.state.formData.date && this.state.formData.timeStart  && this.state.formData.timeEnd ) {
				const fv = [
					this.state.formData.date + ' ' + this.state.formData.timeStart + ':00',
					this.state.formData.date + ' ' + this.state.formData.timeEnd + ':00',
				];
				window.glob.trigger(
					this.props.globPrefix+'changed',
					{ name: this.props.name, value: fv }
				);
			} else {
				window.glob.trigger(
					this.props.globPrefix+'changed',
					{ name: this.props.name, value: undefined }
				);
			}
			window.glob.trigger(
				this.props.globPrefix+'changed',
				{ name: 'conflictDetected', value: this.conflictDetected }
			);
		}
	}
	async fetchSlot() {

	};
	async fetchSlotData(){
		if ( this.fetchingSlotData ) return;
		this.fetchingSlotData = true;
		let reqData = {};
		const newState = {};
		if ( this.props.parent ) {
			reqData = this.props.parent;
			//const slot = await window.glob.api('getSlot',reqData);
			const slot = await window.glob.slot.get(reqData);
			newState.minDate = slot.dtstart;
			newState.maxDate = slot.dtend;
			reqData.slot = slot;
			window.glob.setStatus(this.props.globPrefix+'values',reqData);
		} else {
			const p = window.glob.prop.status["prenotazione.values"];
			reqData.ente = p.ente;
			reqData.slot = p.slot;
			reqData.of = p.of;
		}
		//newState.slotData = await window.glob.api('prenoInSlot', reqData );
		newState.slotData = await window.glob.slot.data(reqData );
		newState.conflitti = await window.glob.slot.conflitti(reqData,reqData);
		this.setState(newState);
		this.updatecomments();
		delete this.fetchingSlotData;
	};
	render() {
		if ( ! this.state.visible ) return <p/>;
		if ( ! Array.isArray(this.state.slotData) ) {
			if ( ! this.fetchingSlotData ) setTimeout( ()=>{ this.fetchSlotData() }, 100);
			return (
				<Row className={"TsInterval TsIntervalProgress"}>
					<Col lg={this.state.labelWidth} />
					<Col lg={this.state.fieldWidth}>
						<p className={"comment"}><IndefiniteProgressbar /></p>
					</Col>
				</Row>
			);
		}
		return (
			<>
				{
					this.state.label ? (
						<Row className={"mt-2 mb-1 TsInterval TsIntervalTitle"}>
							<Col lg={this.state.labelWidth} />
							<Col lg={this.state.fieldWidth}>
								{ this.state.label }
							</Col>
						</Row>
					) : ''
				}
				<Row className={"TsInterval TsIntervalDate"}>
					<Col lg={this.state.labelWidth} style={{alignSelf:"flex-start"}}>
						<Label>Data:</Label>
					</Col>
					<Col lg={this.state.fieldWidth} className={"d-lg-inline-flex align-items-start"}>
						<div className={"TsIntervalField"}>
							<SelectDate
								name={"date"}
								value={this.state.formData.date||""}
								required={true}
								autoFocus={true}
								min={this.state.minDate}
								max={this.state.maxDate}
								globPrefix={this.state.myPrefix}
							/>
						</div>
						<div id={this.uid+"date-comment"} className={"TsIntervalComment"} />
					</Col>
				</Row>
				<Row className={"TsInterval TsIntervalStartTime"}>
					<Col lg={this.state.labelWidth}>
						<Label>Ora di inizio:</Label>
					</Col>
					<Col lg={this.state.fieldWidth} className={"d-lg-inline-flex align-items-center"}>
						<div className={"TsIntervalField"}>
							<SelectTime
								name={"timeStart"}
								value={this.state.formData.timeStart||""}
								autoFocus={! this.state.formData.timeStart }
								required={true}
								min={this.state.minTime}
								max={this.state.maxTime}
								deps={this.props?.parent?.tinizio ? undefined : {date:"date"}}
								globPrefix={this.state.myPrefix}
							/>
						</div>
						<div id={this.uid+"timeStart-comment"} className={"TsIntervalComment"} />
					</Col>
				</Row>
				<Row className={"TsInterval TsIntervalEndTime"}>
					<Col lg={this.state.labelWidth}>
						<Label>Ora di fine:</Label>
					</Col>
					<Col lg={this.state.fieldWidth} className={"d-lg-inline-flex align-items-center"}>
						<div className={"TsIntervalField"}>
							<SelectTime
								name={"timeEnd"}
								value={this.state.formData.timeEnd||""}
								autoFocus={! this.props.timeEnd }
								after={this.state.minTime}
								max={this.state.maxTime}
								required={true}
								deps={this.props?.parent?.tfine ? {after:"timeStart"} : {date:"date",after:"timeStart"}}
								globPrefix={this.state.myPrefix}
							/>
						</div>
						<div id={this.uid+"timeEnd-comment"} className={"TsIntervalComment"} />
					</Col>
				</Row>
			</>
		);
	}
};

export default TsInterval;